import {useState} from 'react';
import ConfirmPopup from './ConfirmPopup';

/**
 * Renders only the Editbutton
 * @returns {JSX.Element} The basic Editbutton.
 */

 const Editbutton = (props) => {
    const [confirmOpen, setConfirmOpen] = useState(false);
        
    return(
        <>
            {!props.disableMode && props.actions?.update && 
                <button type="reset" id="button-reset" className="mfx-button mfx-button-type-icon" title={window.Dictionary.getTranslation(7496)} onClick={props.resetChangeHandler}>
                    <i className="icon-close"></i>
                </button>
            }
            {props.disableMode && props.actions?.update &&
                <button type="button" id="button-edit" className="mfx-button mfx-button-type-icon" title={window.Dictionary.getTranslation(1069)} onClick={() => props.disableChangeHandler(false)}>
                    <i className="icon-edit"></i>
                </button>
            } 
            {!props.disableMode && props.saveChangeHandler &&
               <button type="button" id={props.saveId || 'button-save'} className="mfx-button mfx-button-type-icon" title={window.Dictionary.getTranslation(63)} onClick={props.saveChangeHandler}>
                    <i className="icon-save"></i>     
                </button> 
            }{!props.disableMode && props.submit &&
                <button type="submit"  id="button-submit" className="mfx-button mfx-button-type-icon" title={window.Dictionary.getTranslation(12942)}>
                    <i className="icon-save"></i>     
                </button> 
            }
            {props.deleteChangeHandler && props.actions?.delete &&
                <button type="button" id="button-delete" className="mfx-button mfx-button-type-icon" title={window.Dictionary.getTranslation(64)} onClick={() => setConfirmOpen(true)}>
                    <i className="icon-delete"></i>
                </button>
            }
            {confirmOpen && 
                <ConfirmPopup confirm={props.deleteChangeHandler} stop={() => setConfirmOpen(false)} >
                    {window.Dictionary.getTranslation(props.confirmNotice)}
                </ConfirmPopup>
            }
            
               
        </>
     );
 
 };
 
 export default Editbutton;